import axios, { type AxiosResponse } from 'axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import type { ISportsGroup } from 'core/models/api/sports-group/sports-group-piloting'
import { QUERY_KEY_SPORTS_GROUP } from './useApiGetSportsGroup'
import { GROUPS_NOTIFICATION_SPORTS_DELETE_SUCCEDED } from 'core/constants/translations/groups'
import { useTranslation } from 'react-i18next'

export const useApiDeleteSportsGroup = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation<AxiosResponse, Error, ISportsGroup>({
    mutationFn: (sportsGroup: ISportsGroup) => {
      return axios.delete(`/sports_groups/${sportsGroup.id}`)
    },
    onError: (error: Error) => {
      toast.error(t(error?.message || 'error.global.message'))
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SPORTS_GROUP] })
      toast.success(t(GROUPS_NOTIFICATION_SPORTS_DELETE_SUCCEDED))
    }
  })
}
